// removed by extract-text-webpack-plugin
module.exports = {"root":"Notification_root_3Zl","icon":"Notification_icon_2rb","title":"Notification_title_3QJ","content":"Notification_content_2Q1","slideInDown":"Notification_slideInDown_4xD","slideOutUp":"Notification_slideOutUp_2U8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Notification/Notification.css
 ** module id = 568
 ** module chunks = 0
 **/